import React from "react";
import { isDevelopment } from "../../config/env";
import {
  isChunkLoadError,
  reloadOnceForChunkError,
  reloadPage,
  reportRenderError,
} from "../../utils/renderCrash";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportRenderError(error, errorInfo, "ErrorBoundary");
    reloadOnceForChunkError(error);
  }

  handleRetry = () => {
    if (isChunkLoadError(this.state.error)) {
      reloadPage();
      return;
    }
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '1px solid #ff6b6b',
          borderRadius: '8px',
          backgroundColor: '#ffeaea'
        }}>
          <h3>Something went wrong</h3>
          <p>We encountered an error while rendering this component.</p>
          {isDevelopment && this.state.error && (
            <details style={{ marginTop: '10px' }}>
              <summary>Error Details (for developers)</summary>
              <pre style={{
                backgroundColor: '#f5f5f5',
                padding: '10px',
                borderRadius: '4px',
                fontSize: '12px',
                overflow: 'auto',
                maxHeight: '200px'
              }}>
                {this.state.error?.toString()}
              </pre>
            </details>
          )}
          <button
            type="button"
            onClick={this.handleRetry}
            style={{
              marginTop: '10px',
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
